/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import ApiCalls from '../../custom-classes/api-calls';
import { Col, Card, CardBody, CardTitle, CardHeader, CardFooter} from 'reactstrap';
import { Link } from "react-router-dom";

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/
import LanguageManager from '../../custom-classes/language-manager';
import SessionManager from '../../custom-classes/session-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillAlt, faGraduationCap, faUserGraduate} from '@fortawesome/free-solid-svg-icons';


// Component for subscriptions
class SubscriptionList extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en") }
        });

        this.state = {
            didMount: false,
            subscriptionsList: null
        };
        this.props.addTranslation(global);
    }

    componentDidMount() {
        this.setState({didMount: true});
        this.setSubscriptionList();
    }


    setSubscriptionList(){
        // Verify if there is a token
        let userConnected = SessionManager.getSession()!=null;

        // Get the commercial plans
        let apiCall = ApiCalls.getCommercialPlans();
        let arrOptions = [];

        // After the api call, fill the data
        apiCall.then((data)=>{

            // Set column size
            let columnSize = 12 / data.Plans.length;
            if(columnSize < 4)
                columnSize = 4;

            for(let i=0;i < data.Plans.length;i++)
            {
                // Translate the first selection
                arrOptions.push(
                    <div key={data.Plans[i].PlanDescriptionByLang[0].Id}>
                        <Col lg={{size:columnSize}} md={{size:columnSize}} sm={{size:columnSize}} xs={{size:columnSize}}>
                            <Card>
                                <CardHeader>
                                    <CardTitle>
                                        {data.Plans[i].PlanDescriptionByLang[0].Name}
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <FontAwesomeIcon className="fa-3x" icon={faGraduationCap} />
                                    <p>{data.Plans[i].PlanDescriptionByLang[0].Description}</p>
                                    <FontAwesomeIcon className="fa-3x" icon={faMoneyBillAlt} />
                                    <p>
                                        <Translate id="choose-subscription.price" options={{renderInnerHtml: true}}/>
                                        {' '}
                                        <span className="blue-text"> { data.Plans[i].ClientPrice } </span>
                                    </p>
                                    <FontAwesomeIcon className="fa-3x" icon={faUserGraduate} />
                                    <p>
                                        <Translate id="choose-subscription.profiles-quantity" options={{renderInnerHtml: true}}/>
                                        {' '}
                                        <span className="blue-text"> { data.Plans[i].ProfilesQuantity } </span>
                                    </p>
                                </CardBody>
                                <CardFooter>
                                    {
                                        userConnected ?
                                            <Link className="btn btn-block btn-info" color="link" to="/dashboard">
                                                <Translate id="choose-subscription.subscribe" />
                                            </Link> :
                                            <Link className="btn btn-block btn-info" color="link" to="/register">
                                                <Translate id="choose-subscription.subscribe" />
                                            </Link>
                                    }
                                </CardFooter>
                            </Card>
                        </Col>
                    </div>);
            }
            this.setState({subscriptionsList: arrOptions});
        });
    }

    /**
     * Renders the landing page
     * @returns {XML}
     */
    render()
    {
        return(
            <div>
                <Col lg={{size:12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                    {
                        this.state.didMount ? this.state.subscriptionsList : null
                    }
                </Col>
            </div>
        )
    };
}

export default withLocalize(SubscriptionList);


// WEBPACK FOOTER //
// ./src/components/item-list/subscription-list.js